import { render, staticRenderFns } from "./TipsAndPrivewDilog.vue?vue&type=template&id=5bd2a66c&scoped=true&"
import script from "./TipsAndPrivewDilog.vue?vue&type=script&lang=js&"
export * from "./TipsAndPrivewDilog.vue?vue&type=script&lang=js&"
import style0 from "./TipsAndPrivewDilog.vue?vue&type=style&index=0&id=5bd2a66c&prod&lang=scss&scoped=true&"
import style1 from "./TipsAndPrivewDilog.vue?vue&type=style&index=1&id=5bd2a66c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2a66c",
  null
  
)

export default component.exports